var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatingUndoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9769 0.40627C9.61167 0.412313 6.55621 1.73841 4.30041 3.89418L2.48681 2.08058C1.719 1.31277 0.40625 1.85653 0.40625 2.94234V9.75002C0.40625 10.4231 0.951895 10.9688 1.625 10.9688H8.43268C9.51849 10.9688 10.0623 9.65602 9.29449 8.88821L7.17438 6.76809C8.74169 5.30057 10.7697 4.48766 12.9243 4.46907C17.6164 4.42855 21.5715 8.22572 21.5309 13.0736C21.4925 17.6723 17.7641 21.5313 13 21.5313C10.9115 21.5313 8.93765 20.7859 7.38207 19.421C7.14121 19.2097 6.77747 19.2226 6.55088 19.4491L4.5368 21.4632C4.28939 21.7106 4.30163 22.1139 4.56127 22.3484C6.79443 24.3655 9.75376 25.5938 13 25.5938C19.9553 25.5938 25.5937 19.9554 25.5938 13.0001C25.5938 6.05279 19.9242 0.393829 12.9769 0.40627Z",
    fill: "url(#paint0_linear_10496_10890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10496_10890",
    x1: 13,
    y1: 0.40625,
    x2: 13,
    y2: 25.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00",
    stopOpacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatingUndoIcon);
export default __webpack_public_path__ + "static/media/dating-undo-icon.9c577cb6500d2b694e89e7a4fa959206.svg";
export { ForwardRef as ReactComponent };